import React from 'react'
import { useTranslation } from 'react-i18next';
import Images from '../../assets/images';
import './HowWeDoIt.css';
import { Grid } from '@mui/material';

const HowWeDoIt = () => {
  const { t } = useTranslation();

  return (
    <Grid container className='howWeDoIt'>
      <Grid item xs={12} sm={5} justifyContent={'center'} alignContent={'center'} className='imageContainer'>
        <img className='howWeDoItImage' src={Images.tiim.howWeDoIt} alt='how we do it' />
      </Grid>
      <Grid item xs={12} sm={7} justifyContent={'center'} alignContent={'center'} className='descriptionContainer'>
        <h1>{t(`howWeDoIt.title`)}</h1>
        <h2>{t(`howWeDoIt.description`)}</h2>
        <img className='howWeDoItSteps' src={Images.tiim.howWeDoIt2} alt='how we do it' />
      </Grid>
    </Grid>

  )
}

export default HowWeDoIt 